var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useRef, useEffect } from "react";
import Tooltip from "./Tooltip";
import { Button } from "../Button";
import { useMergeRefs } from "../../../common/useFallbackRef";
var TooltipClick = forwardRef(function (_a, ref) {
    var id = _a.id, text = _a.text, buttonText = _a.buttonText, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "text", "buttonText", "className", "style"]);
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var buttonRef = useRef(null);
    var combinedRef = useMergeRefs([ref, buttonRef]);
    var handleClick = function () { return setIsVisible(function (prev) { return !prev; }); };
    var handleKeyDown = function (event) {
        if (event.key === "Enter" || event.key === " ")
            setIsVisible(function (prev) { return !prev; });
        if (event.key === "Escape")
            setIsVisible(false);
    };
    var handleClickOutside = function (event) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
            setIsVisible(false);
        }
    };
    useEffect(function () {
        if (isVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isVisible]);
    var buttonClass = "fr-btn--tooltip";
    if (className) {
        buttonClass += " ".concat(className);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, __assign({}, otherProps, { ref: combinedRef, className: buttonClass, type: "button", onClick: handleClick, onKeyDown: handleKeyDown, "aria-describedby": id, style: style }), buttonText ? buttonText : "Information contextuelle"),
        React.createElement(Tooltip, { id: id, isVisible: isVisible, text: text, referentRef: buttonRef })));
});
export default TooltipClick;
